import styled from "styled-components";

export const TopNavContainer = styled.section`
  padding: 8px 16px 4px;
  height: 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: ${(props) => props.theme.topNavColor ? props.theme.topNavColor : props.theme.primaryColor};
  font-size: 1.6rem;

  @media (max-width: 992px) {
    display: none;
  }

  p {
    font-size: 1.6rem;
  }

  a {
    text-decoration: none;
    font-weight: 500;
    color: ${(props) => props.theme.topNavColor ? props.theme.topNavColor : props.theme.primaryColor} !important;
  }
`